export function imgSrc(url) {
  return url || "";
}

export const CATEGORIES = [
  { id: "taglieri", label: "Taglieri & Antipasti" },
  { id: "fritti", label: "Fritti" },
  { id: "primi", label: "Primi Piatti" },
  { id: "secondi", label: "Secondi" },
  { id: "pizze_speciali", label: "Pizze Speciali", allergens: "Latte, Glutine", note: "Base senza glutine +1€ · Mozzarella senza lattosio +1€" },
  { id: "pizze_rosse", label: "Pizze Rosse", allergens: "Latte, Glutine", note: "Base senza glutine +1€ · Mozzarella senza lattosio +1€" },
  { id: "pizze_bianche", label: "Pizze Bianche", allergens: "Latte, Glutine", note: "Base senza glutine +1€ · Mozzarella senza lattosio +1€" },
  { id: "panini", label: "Panini & Ciabatte", allergens: "Glutine, Uova" },
  { id: "contorni", label: "Contorni" },
  { id: "bambini", label: "Menù Bambini" },
  { id: "vini_bianchi", label: "Vini Bianchi" },
  { id: "vini_rossi", label: "Vini Rossi" },
  { id: "birre_bottiglia", label: "Birre in Bottiglia" },
  { id: "birre_spina", label: "Birre alla Spina", allergens: "Glutine" },
  { id: "bevande", label: "Bevande" },
  { id: "amari", label: "Amari & Distillati" },
  { id: "caffetteria", label: "Caffetteria" },
];

export const ALLERGEN_LEGEND = ["Latte e derivati", "Glutine", "Uova e derivati", "Pesce", "Crostacei e/o molluschi"];

export const GALLERY_CATEGORIES = [
  { id: "pizza", label: "Pizza" },
  { id: "food", label: "Food" },
  { id: "drink", label: "Drink" },
  { id: "locale", label: "Locale" },
  { id: "serate", label: "Serate" },
];

export function galleryCategoryLabel(id) {
  return GALLERY_CATEGORIES.find((c) => c.id === id)?.label || id;
}

export function waLink(number, text) {
  const digits = (number || "").replace(/[^\d]/g, "");
  const withPrefix = digits.startsWith("39") ? digits : `39${digits}`;
  return `https://wa.me/${withPrefix}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -92, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
